var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { email, required, SimpleForm, TextInput, useTranslate, } from 'react-admin';
import { makeStyles, Link, Typography } from '@material-ui/core';
import isEmpty from 'lodash/isEmpty';
import { SignUpToolbar } from './SignUpToolbar';
import { ConfirmSlider } from '../../ui';
import { getErrorMessage } from '../../useLayer7Notify';
export const SignUpForm = props => {
    const classes = useStyles(props);
    const { onSubmit = () => { }, toolbarProps, serverError } = props;
    let showError = false;
    const { title, form, colorAlert, colorTextSecondary, confirmSliderHeader } = classes, sliderClasses = __rest(classes, ["title", "form", "colorAlert", "colorTextSecondary", "confirmSliderHeader"]);
    const translate = useTranslate();
    const [formConfirmed, setFormConfirmed] = useState(false);
    const [showSliderAlert, setShowSliderAlert] = useState(false);
    const [sliderLabelColor, setSliderLabelColor] = useState('textPrimary');
    const submit = data => {
        const { EmailConfirmation } = data, registration = __rest(data, ["EmailConfirmation"]);
        if (!formConfirmed) {
            setShowSliderAlert(true);
            return;
        }
        onSubmit(registration);
    };
    const sliderChange = (event, value) => {
        if (value === 100) {
            setFormConfirmed(true);
            setSliderLabelColor('textSecondary');
            setShowSliderAlert(false);
        }
        else {
            setFormConfirmed(false);
        }
    };
    const validate = () => {
        if (!isEmpty(serverError) && !showError) {
            const { error } = serverError;
            const message = getErrorMessage(error);
            showError = true;
            return {
                OrganizationName: message,
            };
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(SimpleForm, { className: classes.form, save: submit, toolbar: React.createElement(SignUpToolbar, Object.assign({}, toolbarProps)), redirect: false, validate: validate },
            React.createElement(TextInput, { source: "Email", type: "email", label: "resources.registrations.fields.email", variant: "outlined", fullWidth: true, validate: ValidateEmail }),
            React.createElement(TextInput, { source: "EmailConfirmation", type: "email", label: "resources.registrations.fields.email_confirmation", variant: "outlined", fullWidth: true, validate: ValidateEmailConfirmation }),
            React.createElement(TextInput, { source: "OrganizationName", type: "text", label: "resources.registrations.fields.organization", variant: "outlined", fullWidth: true }),
            React.createElement(TextInput, { source: "OrganizationDescription", type: "text", label: "resources.registrations.fields.organization_description", variant: "outlined", fullWidth: true, multiline: true }),
            React.createElement(React.Fragment, null,
                React.createElement(ConfirmSliderHeader, { classes: classes, sliderLabelColor: sliderLabelColor, showAlert: showSliderAlert }),
                React.createElement(ConfirmSlider, { confirmed: formConfirmed, classes: sliderClasses, onChange: sliderChange, ThumbComponent: ConfirmSliderThumb }))),
        React.createElement(Typography, { variant: "body1", align: "center" },
            React.createElement(Link, { component: RouterLink, to: "/login" }, translate('resources.registrations.actions.login')))));
};
const ValidateEmail = [required(), email()];
const ValidateEmailConfirmation = [
    required(),
    email(),
    validateAreEqual('Email', 'EmailConfirmation'),
];
export function validateAreEqual(field1, field2, message = 'resources.registrations.notifications.email_confirmation_error') {
    return (value, allValues) => {
        return allValues[field1] === allValues[field2] ? undefined : message;
    };
}
const ConfirmSliderThumb = props => {
    const translate = useTranslate();
    return (React.createElement(Typography, Object.assign({ variant: "body2", align: "center" }, props), props.confirmed
        ? translate('resources.registrations.slider.confirmed')
        : translate('resources.registrations.slider.unconfirmed')));
};
const ConfirmSliderHeader = (_a) => {
    var { classes, showAlert, sliderLabelColor } = _a, rest = __rest(_a, ["classes", "showAlert", "sliderLabelColor"]);
    const translate = useTranslate();
    return (React.createElement("div", { className: classes.confirmSliderHeader },
        React.createElement(Typography, { gutterBottom: true, color: sliderLabelColor, classes: {
                colorTextSecondary: classes.colorTextSecondary,
            } }, translate('resources.registrations.fields.robot')),
        showAlert && (React.createElement(Typography, { variant: "caption", gutterBottom: true, color: "textPrimary", classes: { colorTextPrimary: classes.colorAlert } }, translate('resources.registrations.notifications.confirmation_required')))));
};
const useStyles = makeStyles(theme => ({
    form: {
        '& >:first-child': {
            padding: 0,
        },
    },
    title: {
        fontSize: theme.typography.fontSize * 2,
        marginBottom: theme.spacing(6),
        color: theme.palette.getContrastText(theme.palette.background.default),
    },
    root: {
        margin: '-15px 0 20px 0',
        width: '50%',
    },
    thumb: {
        height: 38,
        width: '100%',
        backgroundColor: theme.palette.grey[500],
        color: theme.palette.grey[800],
        borderRadius: 2,
        marginTop: -2,
        marginLeft: 0,
        '&:focus, &:hover, &$active': {
            boxShadow: 'inherit',
        },
        '&:hover': {
            backgroundColor: theme.palette.grey[300],
        },
        '&$disabled': {
            height: 38,
            width: '100%',
            backgroundColor: theme.palette.success.dark,
            color: theme.palette.common.white,
            borderRadius: 2,
            marginTop: -2,
            marginLeft: 0,
        },
    },
    rail: {
        height: 34,
        borderRadius: 2,
        width: '200%',
    },
    track: {
        height: 34,
        borderRadius: 2,
    },
    disabled: {},
    colorTextSecondary: {
        color: theme.palette.success.dark,
    },
    colorAlert: {
        color: theme.palette.error.main,
    },
    confirmSliderHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'baseline',
    },
}), {
    name: 'Layer7SignUpForm',
});
//# sourceMappingURL=SignUpForm.js.map